module.exports = __webpack_public_path__ + "img/i_list_info_chat.223bffdf.svg";